import { Field, ImageField } from '@sitecore-content-sdk/nextjs';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import { IconTypes, SvgIcon } from 'helpers/SvgIcon';
import React from 'react';

type IconProps = {
  fields?: {
    Value?: Field<string>;
    Icon?: ImageField;
  };
  iconClass?: string;
  imageClass?: string;
  classNames?: string;
};

const mapIconName = (iconName: string): IconTypes => {
  const iconMapping: Record<string, IconTypes> = {
    'Calendar-blank': 'calendar-blank',
    'Folder-open': 'folder-open',
    'Device-mobile': 'device-mobile',
    Hospital: 'hospital',
    'Hand-heart': 'hand-heart',
    'Map-pin': 'map-pin',
    'User-three': 'user-three',
    Megaphone: 'megaphone',
    'Folder-simple-plus': 'folder-simple-plus',
    'Calendar-check': 'calendar-check',
    Gift: 'gift',
    // Navigation Card icons below
    calendar: 'calendar-blank',
    phone: 'phone',
    chatBubble: 'chat',
    addPerson: 'user-plus',
    stethoscope: 'stethoscope',
    mentalHealth: 'chat-circle-heart',
    building: 'hospital',
    virtualCare: 'video-camera',
    urgentCare: 'custom-clock',
    fractureCare: 'custom-sling',
    Instagram: 'instagram',
    Linkedin: 'linkedin',
    // Add any other mappings here
  };

  return iconMapping[iconName];
};

const ThemeIconWrapper = (props: IconProps) => {
  const [iconName, setIconName] = React.useState<IconTypes | undefined>(undefined);

  React.useEffect(() => {
    if (props?.fields?.Value?.value) {
      setIconName(mapIconName(props?.fields?.Value?.value));
    }
  }, [props?.fields?.Value?.value]);

  if (props?.fields?.Icon?.value?.src) {
    return (
      <ImageWrapper
        field={props?.fields?.Icon}
        className={props?.imageClass ? props?.imageClass : props?.classNames}
      />
    );
  } else if (iconName) {
    return (
      <SvgIcon
        icon={iconName}
        className={props?.iconClass ? props?.iconClass : props?.classNames}
        viewBox={iconName === 'linkedin' ? '0 0 33 33' : undefined}
      />
    );
  } else {
    return <></>;
  }
};

export default ThemeIconWrapper;
